import { createContext, useContext } from 'react';

export const RoutingSearchBarContext = createContext();

export const useRoutingSearchBarContext = () => useContext(RoutingSearchBarContext);
